import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';

import { Cow } from '../models/cow.model';

@Injectable({
  providedIn: 'root',
})
export class CowService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/herd/secure/cow';

  getCow(internationalCowId: string): Observable<Cow> {
    return this.http.get<Cow>(`${this.baseUrl}/${internationalCowId}`);
  }
}
